<template>
  <div class="teaching-arrange-schedule-import">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    title="批量导入排课"
                    width="900px">
      <DataImportModule import-url="/workspace/manager/teaching/schedule/arrange/batchImport"
                        :extra-params="extraParams"
                        @dataImportSuccess="onImportSuccess">
        <span slot="external">
          <el-button size="mini"
                     @click="hidePopover">关闭窗口</el-button>
        </span>
      </DataImportModule>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
import DataImportModule from '../../../../../../../elements/DataImportModule'
export default {
  name: 'TeachingArrangeScheduleImport',
  components: {
    DataGridDialog,
    DataImportModule
  },
  props: {
    extraParams: Object
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    hidePopover () {
      this.visible = false
    },
    onImportSuccess () {
      this.visible = false
      this.$nextTick(() => {
        this.$emit('refresh')
      })
    }
  }
}
</script>

<style lang="scss">
  .teaching-arrange-schedule-import {

  }
</style>
